export const CALL_INTENTS = [
  { value: 'APPOINTMENT_BOOK', label: 'Appointment Booking' },
  { value: 'APPOINTMENT_RESCHEDULE', label: 'Appointment Rescheduling' },
  { value: 'APPOINTMENT_CANCEL', label: 'Appointment Cancellation' },
  { value: 'APPOINTMENT_INFO', label: 'Appointment Inquiry' },
  { value: 'APPOINTMENT_NOTE', label: 'Appointment Note' },
  { value: 'APPOINTMENT_ETA', label: 'Appointment ETA' },
  { value: 'GENERAL_INFO', label: 'General Information' },
  { value: 'COMPLAINT', label: 'Service Complaint' },
  { value: 'SUBSCRIPTION_CANCEL', label: 'Subscription Cancellation' },
  { value: 'BILLING', label: 'Billing Inquiry' },
  { value: 'ACCOUNT_QUERY', label: 'Account Inquiry' },
  { value: 'NEW_SALES', label: 'Service Estimate' },
  { value: 'JOB_APPLICATION', label: 'Job Application' },
  { value: 'SOLICITATION', label: 'Sales Inquiry' },
  { value: 'REPRESENTATIVE', label: 'Representative Request' },
  { value: 'CALLBACK', label: 'Callback Inquiry' },
  { value: 'UNCLEAR', label: 'No Engagement' },
  { value: 'OTHER', label: 'Other' },
];

export const CALL_OUTCOMES = [
  { value: 'SUCCESS', label: 'Success' },
  { value: 'FAIL', label: 'Failure' },
  { value: 'EXCUSED', label: 'Excused' },
];

export const CALL_HUMAN_REQUEST = [
  { value: 'NONE', label: 'Not Requested' },
  { value: 'IMMEDIATE', label: 'Immediately' },
  { value: 'DURING_CALL', label: 'During Call' },
];
